import { MdChevronLeft, MdChevronRight, MdOutlineToday } from 'react-icons/md';
import { toTitleString } from '../../helpers/utils';
import { IconButton } from '../IconButton';
import { PseudoCalendarContainer } from './styles';
import { useMemo } from 'react';
import { DateUtils } from '../../helpers/dateUtils';

const formatDateToString = (date: Date) => {
    const formattedDate = new Intl.DateTimeFormat('pt-BR', {
        weekday: 'short',
        day: '2-digit',
        month: 'long',
    }).format(date);
    const [weekday, day, ...month] = formattedDate.split(' ');
    return `${toTitleString(weekday)} ${day} ${month.join(' ')}`;
};

export const PseudoCalendar = ({
    date,
    onNext,
    onPrevious,
}: {
    date: Date;
    onNext: () => void;
    onPrevious: () => void;
}) => {
    const isActualDate = useMemo(
        () => DateUtils.calculateDaysDifference(date, new Date()) === 0,
        [date]
    );
    return (
        <PseudoCalendarContainer>
            <MdOutlineToday />
            {formatDateToString(date)}
            <div className="actions-wrapper">
                {!isActualDate && (
                    <IconButton onClick={onPrevious}>
                        <MdChevronLeft />
                    </IconButton>
                )}

                <IconButton onClick={onNext}>
                    <MdChevronRight />
                </IconButton>
            </div>
        </PseudoCalendarContainer>
    );
};
